<template>
  <div class="home">
    <v-container fluid>
      <v-row>
        <v-col cols="12" xl="12">
          <v-img
            style="margin: auto"
            max-width="200"
            src="../assets/avataaars.svg"
          ></v-img>
        </v-col>
      </v-row>
      <v-tabs>
        <v-tab>Games</v-tab>
        <v-tab>Tools</v-tab>
        <v-tab>School</v-tab>
        <v-tab>Software</v-tab>
        <v-tab-item>
          <v-row>
            <v-col
              v-for="project in my_codes.games"
              :key="project.name"
              cols="12"
              sm="6"
              md="4"
            >
              <v-card elevation="5">
                <v-img
                        @click="imgToView=project.sc;imageView = true"
                  class="white--text align-start"
                  height="200px"
                  :src="getImg(project.sc)"
                >
                  <v-card-title style="text-shadow: 0px 4px 10px black;"
                    >{{ project.name }}
                    <v-spacer></v-spacer>
                    <v-avatar>
                      <v-img :src="getImg(project.icon)"> </v-img>
                    </v-avatar>
                  </v-card-title>
                </v-img>

                <v-card-text>{{ project.desc }}</v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    :href="project.to"
                    target="_blank"
                    rounded
                    outlined
                    color="light-blue"
                  >
                    Open! <v-icon class="ml-2"> mdi-open-in-new</v-icon>
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
        </v-tab-item>
        <v-tab-item>
          <v-row>
            <v-col
              v-for="project in my_codes.tools"
              :key="project.name"
              cols="12"
              sm="6"
              md="4"
            >
              <v-card elevation="5">
                <v-img
                        @click="imgToView=project.sc;imageView = true"
                  class="white--text align-start"
                  height="200px"
                  :src="getImg(project.sc)"
                >
                  <v-card-title style="text-shadow: 0px 4px 10px black;"
                    >{{ project.name }}
                    <v-spacer></v-spacer>
                    <v-avatar>
                      <v-img :src="getImg(project.icon)"> </v-img>
                    </v-avatar>
                  </v-card-title>
                </v-img>

                <v-card-text>{{ project.desc }}</v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    :href="project.to"
                    target="_blank"
                    rounded
                    outlined
                    color="light-blue"
                  >
                    Open! <v-icon class="ml-2"> mdi-open-in-new</v-icon>
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
        </v-tab-item>
        <v-tab-item>
          <v-row>
            <v-col
              v-for="project in my_codes.school"
              :key="project.name"
              cols="12"
              sm="6"
              md="4"
            >
              <v-card elevation="5">
                <v-img
                  class="white--text align-start"
                  @click="imgToView=project.sc;imageView = true"
                  height="200px"
                  :src="getImg(project.sc)"
                >
                  <v-card-title style="text-shadow: 0px 4px 10px black;"
                    >{{ project.name }}
                    <v-spacer></v-spacer>
                    <v-avatar>
                      <v-img :src="getImg(project.icon)"> </v-img>
                    </v-avatar>
                  </v-card-title>
                </v-img>
                <v-card-text>{{ project.desc }}</v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    :href="project.to"
                    target="_blank"
                    rounded
                    outlined
                    color="light-blue"
                  >
                    Open! <v-icon class="ml-2"> mdi-open-in-new</v-icon>
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
        </v-tab-item>
        <v-tab-item>
          <v-row>
            <v-col
                    v-for="project in my_codes.software"
                    :key="project.name"
                    cols="12"
                    sm="6"
                    md="4"
            >
              <v-card elevation="5">

                  <v-card-title
                  >{{ project.name }}
                    <v-spacer></v-spacer>
                    <v-avatar>
                      <v-img :src="getImg(project.icon)"> </v-img>
                    </v-avatar>
                  </v-card-title>

                <v-card-text>{{ project.desc }}</v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                          rounded
                          @click="dwnLoadFile(project.f)"
                          outlined
                          color="light-blue"
                  >
                    Download! <v-icon class="ml-2"> mdi-download-outline</v-icon>
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
        </v-tab-item>
      </v-tabs>
    </v-container>
    <v-dialog max-width="700" v-model="imageView">
      <v-img :src="getImg(imgToView)"></v-img>
    </v-dialog>
    <v-snackbar color="primary" v-model="dwnLoadSnack" bottom left>
      Fetching Download...
      <v-spacer>

      </v-spacer>
      <v-progress-circular indeterminate color="white"></v-progress-circular>
    </v-snackbar>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: "Home",
  components: {},
  data: () => ({
    my_codes: {
      games: [
        {
          name: "Tail Trail",
          desc:
            'Tail Trail is a game inspired by the classic "Snake" game! Here, instead of a snake, the player controls a fox' +
            " who's tail grows when it eat's rabbits! Different rabbits have different power-ups! This game is currently available " +
            "on Android, downloadable from the Google Play Store!",
          icon: "tt.png",
          sc: "tt_s_n.png",
          to:
            "https://play.google.com/store/apps/details?id=com.pngstudios.tailtrail"
        }
      ],
      tools: [
        {
          name: "Absence List",
          desc:
            "The Absence List is the tool currently used by the Institute Of Microelectronics at the TU Wien to track absences! This particular one is filled with dummy data " +
            "of course, but feel free to log in and add and remove data. Password is always 12345.",
          icon: "avataaars.png",
          sc: "abs_s.png",
          to: "https://grasserfamily.at/absence-list/new/#/"
        },
        {
          name: "Zchedule Calendar",
          desc:
            "Zchedule is a simple calendar, where you can store events. Events can be edited and deleted." +
            " The user can switch between daily view and monthly view.",
          icon: "Zchedule.png",
          sc: "zh_s.png",
          to: "https://grasserfamily.at/zchedule-calendar/#/"
        },
        {
          name: "Todo Master",
          desc:
            "Todo Master is a simple yet elegant app to keep control of your tasks! Tasks can be added, removed and be marked by an importance.",
          icon: "tm.png",
          sc: "tm_s.png",
          to: "https://grasserfamily.at/todo-master/#/"
        }
      ],
      school: [
        {
          name: "Math Tool",
          desc:
            "The Math Tool is a tool I made to help my school class with our math assignments in about mid-2019.",
          icon: "matht.png",
          sc: "mt_s.png",
          to: "https://grasserfamily.at/math-tool/#/"
        },

        {
          name: "School Companion",
          desc:
            "The School Companion is yet another tool I made to assist my class - But this time with more classes instead of just math.",
          icon: "sc.png",
          sc: "sc_s.png",
          to: "https://grasserfamily.at/school-companion/#/"
        }
      ],
      software: [
        {
          name: "Paul Library 5",
          desc: "PLB5 Is a multi-purpose library for python3, containing a few tedious tasks, and of course my very own "
          + "color module that works in almost all linux terminals. Support for the windows command line is a planned feature!",
          icon: "pyth.png",
          f: "plb5.py"
        }
      ],
    },
    imageView: false,
    imgToView: "tt.png",
    dwnLoadSnack: false
  }),
  methods: {
    getImg(url) {
      return require("../assets/" + url);
    },
    dwnLoadFile(f){
      this.dwnLoadSnack = true
      fetch('https://cors-anywhere.herokuapp.com/https://paul.grasserfamily.at/PyModules/'+f)
              .then(resp => resp.blob())
              .then(blob => {
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.style.display = 'none';
                a.href = url;
                a.download = f;
                document.body.appendChild(a);
                a.click();
                window.URL.revokeObjectURL(url);
                alert('your file has downloaded!'); // or you know, something with better UX...
              })
              .catch(() => alert('oh no!'));
    }
  }
};
</script>
